export default "__VITE_ASSET__DcvyVeRb__"